var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 276,
    height: 52.127,
    viewBox: "0 0 276 52.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CC_Original_Logo",
    "data-name": "CC Original Logo",
    transform: "translate(-38.842 -143.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52776",
    "data-name": "Group 52776",
    transform: "translate(94.416 164.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52775",
    "data-name": "Group 52775",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52774",
    "data-name": "Group 52774",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49313",
    "data-name": "Path 49313",
    d: "M1.016-11.4a9.886,9.886,0,0,1,1.1-4.768,7.666,7.666,0,0,1,3.1-3.124,9.3,9.3,0,0,1,4.564-1.1,8.7,8.7,0,0,1,5.5,1.725,8.048,8.048,0,0,1,2.893,4.85H12.481a2.755,2.755,0,0,0-2.8-2.01,2.816,2.816,0,0,0-2.35,1.155A5.315,5.315,0,0,0,6.463-11.4a5.343,5.343,0,0,0,.869,3.274,2.821,2.821,0,0,0,2.35,1.141,2.751,2.751,0,0,0,2.8-2.01h5.692a8.158,8.158,0,0,1-2.907,4.822A8.607,8.607,0,0,1,9.778-2.418,9.369,9.369,0,0,1,5.213-3.505a7.742,7.742,0,0,1-3.1-3.138A9.85,9.85,0,0,1,1.016-11.4Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#1468a2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52779",
    "data-name": "Group 52779",
    transform: "translate(111.423 164.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52778",
    "data-name": "Group 52778",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52777",
    "data-name": "Group 52777",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49314",
    "data-name": "Path 49314",
    d: "M10.036-2.418A9.679,9.679,0,0,1,5.417-3.505,8.094,8.094,0,0,1,2.184-6.643,9.363,9.363,0,0,1,1.016-11.4,9.362,9.362,0,0,1,2.2-16.152a8.052,8.052,0,0,1,3.26-3.138,9.69,9.69,0,0,1,4.632-1.1,9.7,9.7,0,0,1,4.632,1.1,7.969,7.969,0,0,1,3.26,3.138,9.3,9.3,0,0,1,1.2,4.755,9.166,9.166,0,0,1-1.209,4.741,8.219,8.219,0,0,1-3.287,3.152A9.846,9.846,0,0,1,10.036-2.418Zm0-4.632a3.461,3.461,0,0,0,2.608-1.128,4.455,4.455,0,0,0,1.087-3.22,4.551,4.551,0,0,0-1.06-3.233,3.39,3.39,0,0,0-2.581-1.128A3.391,3.391,0,0,0,7.5-14.644,4.613,4.613,0,0,0,6.463-11.4a4.636,4.636,0,0,0,1.019,3.22A3.287,3.287,0,0,0,10.036-7.051Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#1468a2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52782",
    "data-name": "Group 52782",
    transform: "translate(130.491 158.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52781",
    "data-name": "Group 52781",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52780",
    "data-name": "Group 52780",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49315",
    "data-name": "Path 49315",
    d: "M7.587-26.656V-3.481H2.234V-26.656Zm0,0",
    transform: "translate(-2.234 26.656)",
    fill: "#1468a2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52785",
    "data-name": "Group 52785",
    transform: "translate(137.789 158.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52784",
    "data-name": "Group 52784",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52783",
    "data-name": "Group 52783",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49316",
    "data-name": "Path 49316",
    d: "M7.587-26.656V-3.481H2.234V-26.656Zm0,0",
    transform: "translate(-2.234 26.656)",
    fill: "#1468a2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52788",
    "data-name": "Group 52788",
    transform: "translate(144.027 164.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52787",
    "data-name": "Group 52787",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52786",
    "data-name": "Group 52786",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49317",
    "data-name": "Path 49317",
    d: "M18.553-11.683a14,14,0,0,1-.1,1.562H6.341a3.651,3.651,0,0,0,1.046,2.5,3.212,3.212,0,0,0,2.269.856,2.8,2.8,0,0,0,2.785-1.7h5.705a7.82,7.82,0,0,1-1.589,3.111,7.941,7.941,0,0,1-2.866,2.16,9.233,9.233,0,0,1-3.844.774A9.441,9.441,0,0,1,5.268-3.505,7.828,7.828,0,0,1,2.143-6.643,9.632,9.632,0,0,1,1.016-11.4a9.886,9.886,0,0,1,1.1-4.768A7.657,7.657,0,0,1,5.227-19.29a9.458,9.458,0,0,1,4.619-1.1,9.309,9.309,0,0,1,4.51,1.073,7.672,7.672,0,0,1,3.084,3.029A9.228,9.228,0,0,1,18.553-11.683ZM13.065-13.1a2.754,2.754,0,0,0-.937-2.187,3.455,3.455,0,0,0-2.35-.815,3.385,3.385,0,0,0-2.269.788A3.419,3.419,0,0,0,6.368-13.1Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#1468a2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52791",
    "data-name": "Group 52791",
    transform: "translate(161.378 164.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52790",
    "data-name": "Group 52790",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52789",
    "data-name": "Group 52789",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49318",
    "data-name": "Path 49318",
    d: "M8.718-20.391a6.742,6.742,0,0,1,3.233.747,5.49,5.49,0,0,1,2.146,1.97v-2.472h5.366V-2.69A9.741,9.741,0,0,1,18.5,1.671a7.239,7.239,0,0,1-2.907,3.124A9.484,9.484,0,0,1,10.715,5.95a10.147,10.147,0,0,1-6.3-1.834A6.9,6.9,0,0,1,1.668-.843h5.3A2.484,2.484,0,0,0,8.147.733a4.367,4.367,0,0,0,2.323.584A3.6,3.6,0,0,0,13.106.353,4.073,4.073,0,0,0,14.1-2.69V-5.162a5.928,5.928,0,0,1-2.16,1.983,6.522,6.522,0,0,1-3.219.761,7.269,7.269,0,0,1-3.926-1.1A7.687,7.687,0,0,1,2.021-6.684a10.637,10.637,0,0,1-1.005-4.755,10.528,10.528,0,0,1,1.005-4.727A7.548,7.548,0,0,1,4.792-19.29,7.269,7.269,0,0,1,8.718-20.391ZM14.1-11.4a4.383,4.383,0,0,0-1.114-3.165,3.576,3.576,0,0,0-2.7-1.168,3.621,3.621,0,0,0-2.7,1.155,4.3,4.3,0,0,0-1.114,3.138A4.459,4.459,0,0,0,7.577-8.246a3.585,3.585,0,0,0,2.7,1.168,3.588,3.588,0,0,0,2.7-1.155A4.405,4.405,0,0,0,14.1-11.4Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#1468a2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52794",
    "data-name": "Group 52794",
    transform: "translate(180.703 164.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52793",
    "data-name": "Group 52793",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52792",
    "data-name": "Group 52792",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49319",
    "data-name": "Path 49319",
    d: "M18.553-11.683a14,14,0,0,1-.1,1.562H6.341a3.651,3.651,0,0,0,1.046,2.5,3.212,3.212,0,0,0,2.269.856,2.8,2.8,0,0,0,2.785-1.7h5.705a7.82,7.82,0,0,1-1.589,3.111,7.941,7.941,0,0,1-2.866,2.16,9.233,9.233,0,0,1-3.844.774A9.441,9.441,0,0,1,5.268-3.505,7.828,7.828,0,0,1,2.143-6.643,9.632,9.632,0,0,1,1.016-11.4a9.886,9.886,0,0,1,1.1-4.768A7.657,7.657,0,0,1,5.227-19.29a9.458,9.458,0,0,1,4.619-1.1,9.309,9.309,0,0,1,4.51,1.073,7.672,7.672,0,0,1,3.084,3.029A9.228,9.228,0,0,1,18.553-11.683ZM13.065-13.1a2.754,2.754,0,0,0-.937-2.187,3.455,3.455,0,0,0-2.35-.815,3.385,3.385,0,0,0-2.269.788A3.419,3.419,0,0,0,6.368-13.1Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#1468a2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52797",
    "data-name": "Group 52797",
    transform: "translate(202.752 164.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52796",
    "data-name": "Group 52796",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52795",
    "data-name": "Group 52795",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49320",
    "data-name": "Path 49320",
    d: "M1.016-11.4a9.886,9.886,0,0,1,1.1-4.768,7.666,7.666,0,0,1,3.1-3.124,9.3,9.3,0,0,1,4.564-1.1,8.7,8.7,0,0,1,5.5,1.725,8.048,8.048,0,0,1,2.893,4.85H12.481a2.755,2.755,0,0,0-2.8-2.01,2.816,2.816,0,0,0-2.35,1.155A5.315,5.315,0,0,0,6.463-11.4a5.343,5.343,0,0,0,.869,3.274,2.821,2.821,0,0,0,2.35,1.141,2.751,2.751,0,0,0,2.8-2.01h5.692a8.158,8.158,0,0,1-2.907,4.822A8.607,8.607,0,0,1,9.778-2.418,9.369,9.369,0,0,1,5.213-3.505a7.742,7.742,0,0,1-3.1-3.138A9.85,9.85,0,0,1,1.016-11.4Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#1468a2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52800",
    "data-name": "Group 52800",
    transform: "translate(219.759 164.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52799",
    "data-name": "Group 52799",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52798",
    "data-name": "Group 52798",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49321",
    "data-name": "Path 49321",
    d: "M10.036-2.418A9.679,9.679,0,0,1,5.417-3.505,8.094,8.094,0,0,1,2.184-6.643,9.363,9.363,0,0,1,1.016-11.4,9.362,9.362,0,0,1,2.2-16.152a8.052,8.052,0,0,1,3.26-3.138,9.69,9.69,0,0,1,4.632-1.1,9.7,9.7,0,0,1,4.632,1.1,7.969,7.969,0,0,1,3.26,3.138,9.3,9.3,0,0,1,1.2,4.755,9.166,9.166,0,0,1-1.209,4.741,8.219,8.219,0,0,1-3.287,3.152A9.846,9.846,0,0,1,10.036-2.418Zm0-4.632a3.461,3.461,0,0,0,2.608-1.128,4.455,4.455,0,0,0,1.087-3.22,4.551,4.551,0,0,0-1.06-3.233,3.39,3.39,0,0,0-2.581-1.128A3.391,3.391,0,0,0,7.5-14.644,4.613,4.613,0,0,0,6.463-11.4a4.636,4.636,0,0,0,1.019,3.22A3.287,3.287,0,0,0,10.036-7.051Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#1468a2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52803",
    "data-name": "Group 52803",
    transform: "translate(238.828 164.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52802",
    "data-name": "Group 52802",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52801",
    "data-name": "Group 52801",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49322",
    "data-name": "Path 49322",
    d: "M12.885-20.328a6.339,6.339,0,0,1,4.9,2,7.742,7.742,0,0,1,1.834,5.461V-2.655H14.3v-9.5a3.819,3.819,0,0,0-.91-2.717,3.183,3.183,0,0,0-2.445-.978,3.173,3.173,0,0,0-2.445.978,3.8,3.8,0,0,0-.91,2.717v9.5H2.234V-20.138H7.587v2.323a5.751,5.751,0,0,1,2.187-1.834A6.986,6.986,0,0,1,12.885-20.328Zm0,0",
    transform: "translate(-2.234 20.328)",
    fill: "#1468a2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52806",
    "data-name": "Group 52806",
    transform: "translate(256.705 160.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52805",
    "data-name": "Group 52805",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52804",
    "data-name": "Group 52804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49323",
    "data-name": "Path 49323",
    d: "M11.781-7.8v4.537H9.064A6.68,6.68,0,0,1,4.513-4.691q-1.63-1.426-1.63-4.646v-6.955H.75v-4.456H2.883V-25H8.249v4.252h3.5v4.456h-3.5v7.01a1.525,1.525,0,0,0,.367,1.141,1.846,1.846,0,0,0,1.25.34Zm0,0",
    transform: "translate(-0.75 25)",
    fill: "#1468a2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52809",
    "data-name": "Group 52809",
    transform: "translate(267.71 164.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52808",
    "data-name": "Group 52808",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52807",
    "data-name": "Group 52807",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49324",
    "data-name": "Path 49324",
    d: "M1.016-11.439a10.528,10.528,0,0,1,1.005-4.727A7.548,7.548,0,0,1,4.792-19.29a7.269,7.269,0,0,1,3.926-1.1,6.742,6.742,0,0,1,3.233.747,5.49,5.49,0,0,1,2.146,1.97v-2.472h5.366V-2.663H14.1V-5.135a5.665,5.665,0,0,1-2.174,1.97,6.7,6.7,0,0,1-3.233.747,7.218,7.218,0,0,1-3.9-1.1A7.687,7.687,0,0,1,2.021-6.684,10.637,10.637,0,0,1,1.016-11.439ZM14.1-11.4a4.383,4.383,0,0,0-1.114-3.165,3.576,3.576,0,0,0-2.7-1.168,3.621,3.621,0,0,0-2.7,1.155,4.3,4.3,0,0,0-1.114,3.138A4.459,4.459,0,0,0,7.577-8.246a3.585,3.585,0,0,0,2.7,1.168,3.588,3.588,0,0,0,2.7-1.155A4.405,4.405,0,0,0,14.1-11.4Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#1468a2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52812",
    "data-name": "Group 52812",
    transform: "translate(287.035 164.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52811",
    "data-name": "Group 52811",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52810",
    "data-name": "Group 52810",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49325",
    "data-name": "Path 49325",
    d: "M1.016-11.4a9.886,9.886,0,0,1,1.1-4.768,7.666,7.666,0,0,1,3.1-3.124,9.3,9.3,0,0,1,4.564-1.1,8.7,8.7,0,0,1,5.5,1.725,8.048,8.048,0,0,1,2.893,4.85H12.481a2.755,2.755,0,0,0-2.8-2.01,2.816,2.816,0,0,0-2.35,1.155A5.315,5.315,0,0,0,6.463-11.4a5.343,5.343,0,0,0,.869,3.274,2.821,2.821,0,0,0,2.35,1.141,2.751,2.751,0,0,0,2.8-2.01h5.692a8.158,8.158,0,0,1-2.907,4.822A8.607,8.607,0,0,1,9.778-2.418,9.369,9.369,0,0,1,5.213-3.505a7.742,7.742,0,0,1-3.1-3.138A9.85,9.85,0,0,1,1.016-11.4Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#1468a2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52815",
    "data-name": "Group 52815",
    transform: "translate(303.811 160.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52814",
    "data-name": "Group 52814",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52813",
    "data-name": "Group 52813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49326",
    "data-name": "Path 49326",
    d: "M11.781-7.8v4.537H9.064A6.68,6.68,0,0,1,4.513-4.691q-1.63-1.426-1.63-4.646v-6.955H.75v-4.456H2.883V-25H8.249v4.252h3.5v4.456h-3.5v7.01a1.525,1.525,0,0,0,.367,1.141,1.846,1.846,0,0,0,1.25.34Zm0,0",
    transform: "translate(-0.75 25)",
    fill: "#1468a2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52818",
    "data-name": "Group 52818",
    transform: "translate(54.605 143.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52817",
    "data-name": "Group 52817",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52816",
    "data-name": "Group 52816",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49327",
    "data-name": "Path 49327",
    d: "M17.71,2.516a18.666,18.666,0,0,1,9.333,2.337,17.082,17.082,0,0,1,6.48,6.385,17.564,17.564,0,0,1,2.35,8.979,18.213,18.213,0,0,1-2.8,10.12,16.052,16.052,0,0,1-7.933,6.317V31.111a11.16,11.16,0,0,0,4.931-4.252A12.338,12.338,0,0,0,31.8,20.216a13.024,13.024,0,0,0-1.725-6.67,12.1,12.1,0,0,0-4.9-4.632A15.811,15.811,0,0,0,17.71,7.243a15.682,15.682,0,0,0-7.4,1.671,12.174,12.174,0,0,0-4.918,4.632,12.991,12.991,0,0,0-1.725,6.67,12.45,12.45,0,0,0,1.7,6.643,11.051,11.051,0,0,0,4.918,4.252v5.542a15.908,15.908,0,0,1-7.852-6.317A18.337,18.337,0,0,1-.344,20.216a17.771,17.771,0,0,1,2.309-8.979A16.913,16.913,0,0,1,8.391,4.852,18.569,18.569,0,0,1,17.71,2.516Zm0,0",
    transform: "translate(0.344 -2.516)",
    fill: "#44a4eb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52821",
    "data-name": "Group 52821",
    transform: "translate(38.842 161.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52820",
    "data-name": "Group 52820",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52819",
    "data-name": "Group 52819",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49328",
    "data-name": "Path 49328",
    d: "M-23.15-7.644A18.666,18.666,0,0,1-32.483-9.98a17.082,17.082,0,0,1-6.48-6.385,17.564,17.564,0,0,1-2.35-8.979,18.213,18.213,0,0,1,2.8-10.12,16.052,16.052,0,0,1,7.933-6.317v5.542a11.16,11.16,0,0,0-4.931,4.252,12.338,12.338,0,0,0-1.725,6.643,13.024,13.024,0,0,0,1.725,6.67,12.1,12.1,0,0,0,4.9,4.632,15.811,15.811,0,0,0,7.458,1.671,15.682,15.682,0,0,0,7.4-1.671,12.174,12.174,0,0,0,4.918-4.632A12.991,12.991,0,0,0-9.1-25.344a12.45,12.45,0,0,0-1.7-6.643,11.051,11.051,0,0,0-4.918-4.252v-5.542a15.908,15.908,0,0,1,7.852,6.317A18.337,18.337,0,0,1-5.1-25.344a17.771,17.771,0,0,1-2.309,8.979A16.913,16.913,0,0,1-13.831-9.98,18.569,18.569,0,0,1-23.15-7.644Zm0,0",
    transform: "translate(41.312 41.781)",
    fill: "#1468a2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcLogo);
export default __webpack_public_path__ + "static/media/CC-Logo.e8d268d94473de68d497ae9c37831e9f.svg";
export { ForwardRef as ReactComponent };